var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFinancialQuestionMarkIcon = function SvgFinancialQuestionMarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.502a2.248 2.248 0 0 1 4.37.75c0 1.499-2.25 2.248-2.25 2.248m.03 3h.01M8.4 17.2l1.46 1.947c.217.29.326.434.459.486a.5.5 0 0 0 .362 0c.133-.052.242-.197.459-.486L12.6 17.2c.293-.39.44-.586.619-.735a2 2 0 0 1 .822-.412C14.267 16 14.51 16 15 16c1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624c.228-.551.228-1.25.228-2.648V5.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.22 1 16.38 1 14.7 1H6.3c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C1.5 3.28 1.5 4.12 1.5 5.8v5.7c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C3.903 16 4.602 16 6 16c.489 0 .733 0 .96.053a2 2 0 0 1 .822.412c.178.149.325.344.618.735Z",
    stroke: "#4A49BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFinancialQuestionMarkIcon;